module.exports = __webpack_public_path__ + "static/img/TRANSPORTATION.59044d43.png";